// Menu roots carry the exhibition's own order; children keep Craft's order.
const position = (item = {}) => item.menuOrder ?? item.lft ?? 0;
export const byMenuOrder = (a, b) => position(a) - position(b);

// Keep gallery landing redirects in the same order as the sidebar.
export const topLevelGalleries = (pages) =>
  pages
    .filter(
      ({ context }) => context.template === "gallery" && context.level === 1,
    )
    .sort((a, b) => byMenuOrder(a.context, b.context));

export function galleryDestination(context, pages) {
  if (context.template === "gallery-index")
    return topLevelGalleries(pages)[0]?.path;
  if (context.template === "gallery" && context.subpages?.[0]?.uri)
    return `/${context.baseUri}/${context.subpages[0].uri}/`;
  return null;
}
